module.exports = __webpack_public_path__ + "static/media/arrow.cd0cbf0c.svg";